"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFaviconFromTheme = void 0;
const styled_components_1 = require("styled-components");
const react_1 = __importDefault(require("react"));
exports.useFaviconFromTheme = () => {
    const theme = react_1.default.useContext(styled_components_1.ThemeContext);
    react_1.default.useEffect(() => {
        const link = document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = theme.favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
    }, [theme]);
};
//# sourceMappingURL=useFaviconFromTheme.js.map